var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var timeUnits = [
    ['Y', 1000 * 60 * 60 * 24 * 365],
    ['M', 1000 * 60 * 60 * 24 * 30],
    ['D', 1000 * 60 * 60 * 24],
    ['H', 1000 * 60 * 60],
    ['m', 1000 * 60],
    ['s', 1000],
    ['S', 1],
];
export function formatTimeStr(duration, format) {
    var leftDuration = duration;
    var escapeRegex = /\[[^\]]*]/g;
    var keepList = (format.match(escapeRegex) || []).map(function (str) { return str.slice(1, -1); });
    var templateText = format.replace(escapeRegex, '[]');
    var formatTime = {};
    var replacedText = timeUnits.reduce(function (current, _a) {
        var _b = __read(_a, 2), name = _b[0], unit = _b[1];
        if (current.indexOf(name) !== -1) {
            var value_1 = Math.floor(leftDuration / unit);
            formatTime[name] = value_1;
            leftDuration -= value_1 * unit;
            return current.replace(new RegExp(name + "+", 'g'), function (match) {
                var len = match.length;
                return value_1.toString().padStart(len, '0');
            });
        }
        return current;
    }, templateText);
    var index = 0;
    var formatStr = replacedText.replace(escapeRegex, function () {
        var match = keepList[index];
        index += 1;
        return match;
    });
    return {
        formatStr: formatStr,
        formatTime: formatTime,
    };
}
